import { useRef, useEffect } from "react";
import { X, Play } from "react-feather";
import styles from "./journaldetails.module.css";

const VideoThumbnail = ({ videoUrl }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            const handleLoadedData = () => {
                // Pause immediately once first frame loads
                video.currentTime = 0;
                video.pause();
            };
            video.addEventListener("loadeddata", handleLoadedData);
            return () => video.removeEventListener("loadeddata", handleLoadedData);
        }
    }, []);

    return (
        <div>
            <video
                ref={videoRef}
                src={videoUrl}
                muted
                playsInline
                preload="metadata"
                className={styles.videoPreview}
            />

            <span className={styles.playIcon}>
                <Play size={18} />
            </span>
        </div>
    );
};

export default VideoThumbnail;